<template>


    <Transition name="modal-fade">
      <div v-if="isdisplay" class="cf-overlay" @click.self="close">
        <Transition name="modal-slide">
          <div v-if="isdisplay" class="cf-dialog cf-dialog--xxl">

                <!-- Header -->
                <div class="cf-modal-head cf-dialog-head">
                    <div class="cf-modal-head__main">
                        <span class="cf-modal-head__icon"><i class="ri-user-star-line"></i></span>
                        <div>
                            <h4 class="cf-dialog-title">{{ titlemodal }}</h4>
                            <p class="cf-modal-head__sub">Top 10 des meilleurs clients et des créances clients</p>
                        </div>
                    </div>
                    <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                </div>

                <!-- Body -->
                <div class="cf-dialog-body">



                    <div class="box  overflow-hidden">
                        <div class="box-header justify-between " style="display: block">



                            <div class="grid grid-cols-12  gap-x-6">

                                <div class="xl:col-span-6 mt-3  col-span-12">
                                    <label  class="form-label">Année</label>
                                    <select  @change="loadupdate" v-model="manne"
                                            class="form-control ti-select w-full">
                                        <option v-for="(anne,index) of listedesannees" :key="index" :value="anne">{{anne}}</option>
                                    </select>
                                </div>

                                <div class="xl:col-span-6 mt-3 mb-3 col-span-12">
                                    <label  class="form-label">Affichage en</label>

                                    <select v-model="typaffiche"
                                            class="form-control ti-select w-full">
                                        <option value="Graph">Graph</option>
                                        <option value="Tableau">Tableau</option>
                                    </select>


                                </div>



                            </div>



                        </div>



                        <div v-show="typaffiche==='Tableau'" class="box-body !p-0 mybodyheight300px">

                            <div  class="grid grid-cols-12 mt-7 gap-6">



                            <div class="table-responsive xl:col-span-6 col-span-12">

                                    <div class="box custom-box">
                                        <div class="box-header justify-between">
                                            <div class="box-title">
                                                TOP 10 DES MEILLEURS CLIENTS
                                            </div>

                                        </div>
                                        <div class="box-body">


                                            <div class="flex flex-col h-screen">
                                                <div class="flex-grow overflow-auto">

                                                    <table class="relative w-full border table mytable table-hover whitespace-nowrap overflow-x-scroll min-w-full">
                                                        <thead>
                                                        <tr>
                                                            <th scope="col" class="th text-start">CLIENT</th>
                                                            <th scope="col" class="th text-start">MONTANT</th>


                                                        </tr>
                                                        </thead>
                                                        <tbody>

                                                        <template v-if="dataclient.length">

                                                        <tr  class="table-row" v-for="(datavalue,index) in dataclient" :key="index">

                                                            <td class="td"  data-label="CLIENT  : "   >{{ datavalue.raisonsociale }}</td>
                                                            <td class="td td--center" data-label="MONTANT  : "   >{{ formatMoney(datavalue.montanttotal) }}</td>

                                                        </tr>

                                                        </template>

                                                        <template v-else>
                                                            <tr>
                                                                <td colspan="2">
                                                                    <div class="empty-state">
                                                                        <div class="empty-state__icon"><i class="ri-user-star-line"></i></div>
                                                                        <p class="empty-state__title">Aucun client trouvé</p>
                                                                        <p class="empty-state__sub">Aucune donnée pour l'année sélectionnée</p>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </template>

                                                        </tbody>

                                                    </table>


                                                </div>
                                            </div>


                                        </div>
                                        <div class="box-footer border-t-0 hidden">

                                        </div>
                                    </div>

                            </div>



                            <div class="table-responsive xl:col-span-6 col-span-12">

                                <div class="box custom-box">
                                    <div class="box-header justify-between">
                                        <div class="box-title">
                                            TOP 10 DES CREANCES CLIENTS
                                        </div>

                                    </div>
                                    <div class="box-body">


                                        <div class="flex flex-col h-screen">
                                            <div class="flex-grow overflow-auto">


                                                <table class="relative w-full border table mytable table-hover whitespace-nowrap overflow-x-scroll min-w-full">
                                                    <thead>
                                                    <tr>
                                                        <th scope="col" class="th text-start">CLIENT</th>
                                                        <th scope="col" class="th text-start">MONTANT</th>


                                                    </tr>
                                                    </thead>
                                                    <tbody>

                                                    <template v-if="datacreance.length">

                                                    <tr  class="table-row" v-for="(datavalue,index) in datacreance" :key="index">

                                                        <td class="td"  data-label="CLIENT  : "   >{{ datavalue.raisonsociale }}</td>
                                                        <td class="td td--center" data-label="MONTANT  : "   >{{ formatMoney(datavalue.montanttotal) }}</td>

                                                    </tr>

                                                    </template>

                                                    <template v-else>
                                                        <tr>
                                                            <td colspan="2">
                                                                <div class="empty-state">
                                                                    <div class="empty-state__icon"><i class="ri-hand-coin-line"></i></div>
                                                                    <p class="empty-state__title">Aucune créance trouvée</p>
                                                                    <p class="empty-state__sub">Aucune donnée pour l'année sélectionnée</p>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </template>

                                                    </tbody>

                                                </table>



                                            </div>
                                        </div>


                                    </div>
                                    <div class="box-footer border-t-0 hidden">

                                    </div>
                                </div>

                            </div>





                            </div>
                        </div>



                        <div v-show="typaffiche==='Graph'" class="box-body !p-0 mybodyheight500px">

                       <div  class="grid grid-cols-12 mt-7 gap-6">

                            <div class="xl:col-span-6 col-span-12">
                                <div class="box custom-box">
                                    <div class="box-header justify-between">
                                        <div class="box-title">
                                            TOP 10 DES MEILLEURS CLIENTS
                                        </div>

                                    </div>
                                    <div class="box-body">


                                        <div id="chart">
                                            <apexcharts ref="apexChart" type="pie" height="350"
                                                        :options="chartOptions1" :series="series1"></apexcharts>
                                        </div>



                                    </div>
                                    <div class="box-footer border-t-0 hidden">

                                    </div>
                                </div>
                            </div>


                            <div class="xl:col-span-6 col-span-12">
                                <div class="box custom-box">
                                    <div class="box-header justify-between">
                                        <div class="box-title">
                                            TOP 10 DES CREANCES CLIENTS
                                        </div>

                                    </div>
                                    <div class="box-body">


                                        <div id="chart2">
                                            <apexcharts ref="apexChart1" type="pie" height="350"
                                                        :options="chartOptions1" :series="series1"></apexcharts>
                                        </div>



                                    </div>
                                    <div class="box-footer border-t-0 hidden">

                                    </div>
                                </div>
                            </div>



                        </div>



                        </div>


                    </div>






                </div>
                <!-- Footer -->
                <div class="cf-dialog-foot">
                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                </div>

          </div>
        </Transition>
      </div>
    </Transition>



</template>

<script>

    import VueApexCharts from "vue3-apexcharts";


    const axios =require('axios');


    import {currencyFormatDE, currentMonth, currentYear, getYear2020, randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";

    export default {
        /* eslint-disable */
        name: "formsupp",

        watch: {
            searchword: function(newvalue,oldvalue){

                this.page=1

            },

            searchtrierletableau: function(newvalue,oldvalue){

                this.page=1

            },


        },
        computed:{

            displayedPages() {
                const start = Math.max(1, this.page - 5);
                const end = Math.min(this.pages.length, start + 9);

                let result = [];

                if (start > 1) {
                    result.push(1);
                    if (start > 2) {
                        result.push('...');
                    }
                }

                for (let i = start; i <= end; i++) {
                    result.push(i);
                }

                if (end < this.pages.length) {
                    if (end < this.pages.length - 1) {
                        result.push('...');
                    }
                    result.push(this.pages.length);
                }

                return result;
            },
            filterdatatable(){

                let mvalue=this.datatable;

                //this.page=this.Defaultpage;
                this.perPage=this.DefaultperPage;

                let t=this

                t.mmontanttotal=0;

                mvalue.forEach(function ($line) {
                    t.mmontanttotal=parseFloat(t.mmontanttotal)+parseFloat($line.mmontant);
                })





                return this.paginate(mvalue) ;
            },
        },
        components: {
            apexcharts: VueApexCharts,

        },

        data() {
            return {
                isdisplay:false,
                titlemodal:"",

                mmontanttotal:0,
                mmois:currentMonth(),
                manne:currentYear(),
                listedesannees:[],
                typaffiche:'Graph',

                datatable:[],
                afichagetable:[],
                alldata:[],

                allgraphsclient:[],
                allgraphscreance:[],

                dataclient:[],
                datacreance:[],


                labels:[],
                dataset:[],


                series: [],
                chartOptions: {
                    chart: {
                        width: 380,
                        type: 'pie',
                    },
                    labels: [],
                    colors:[],
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }]
                },

                series1: [],
                chartOptions1: {
                    chart: {
                        width: 380,
                        type: 'pie',
                    },
                    labels: [],
                    colors:[],
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }]
                },



                posts : [''],
                page: 1,
                // perPage: 100,
                perPage: 50,
                Defaultpage: 1,
                DefaultperPage: 50,
                pages: [],
            };
        },
        methods: {


            formatMoney(num) {

                return  currencyFormatDE(num)
            },


            async loadupdate(){


                        this.$store.dispatch('lancerchargement',true)

                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egldsds74gescom8571714dfe/rapport/gescom/'+this.manne+'/'+this.mmois+'/'+this.$store.state.appsociete+'/rttu44cltessentiel785488kjuii_0287845854/'+randomString();
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)


                        if(res.data.success){

                            t.dataclient=[];
                            t.datacreance=[];
                            t.allgraphsclient=[];
                            t.allgraphscreance=[];

                            t.dataclient=res.data.dt1;
                            t.datacreance=res.data.dt2;

                            t.allgraphsclient=res.data.gph1;
                            t.allgraphscreance=res.data.gph2;


                            t.series=t.allgraphsclient.dataset;
                            t.series1=t.allgraphscreance.dataset;

                            t.chartOptions.labels=t.allgraphsclient.labels;
                            t.chartOptions1.labels=t.allgraphscreance.labels;

                            t.chartOptions.colors=t.allgraphsclient.backgroundColor;
                            t.chartOptions1.colors=t.allgraphscreance.backgroundColor;



                            //t.$refs.apexChart.updateOptions(t.chartOptions);
                            //t.$refs.apexChart1.updateOptions(t.chartOptions1);


                            t.$refs.apexChart.updateOptions({
                                labels: t.allgraphsclient.labels,
                                colors: t.allgraphsclient.backgroundColor
                            });
                            t.$refs.apexChart1.updateOptions({
                                labels: t.allgraphscreance.labels,
                                colors: t.allgraphscreance.backgroundColor
                            });



                        }
                        else{
                            t.dataclient=[];
                            t.datacreance=[];
                            t.allgraphsclient=[];
                            t.allgraphscreance=[];

                            t.$refs.apexChart.updateOptions(t.chartOptions);
                            t.$refs.apexChart1.updateOptions(t.chartOptions1);


                        }


                    })
                    .catch((error)=>{

                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })




            },

            async load(){


                        this.$store.dispatch('lancerchargement',true)

                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egldsds74gescom8571714dfe/rapport/gescom/'+this.manne+'/'+this.mmois+'/'+this.$store.state.appsociete+'/rttu44cltessentiel785488kjuii_0287845854/'+randomString();
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)


                        if(res.data.success){

                            t.dataclient=[];
                            t.datacreance=[];
                            t.allgraphsclient=[];
                            t.allgraphscreance=[];

                            t.dataclient=res.data.dt1;
                            t.datacreance=res.data.dt2;

                            t.allgraphsclient=res.data.gph1;
                            t.allgraphscreance=res.data.gph2;


                            t.series=t.allgraphsclient.dataset;
                            t.series1=t.allgraphscreance.dataset;

                            t.chartOptions.labels=t.allgraphsclient.labels;
                            t.chartOptions1.labels=t.allgraphscreance.labels;

                            t.chartOptions.colors=t.allgraphsclient.backgroundColor;
                            t.chartOptions1.colors=t.allgraphscreance.backgroundColor;

                            t.isdisplay=true;

                        }
                        else{
                            t.dataclient=[];
                            t.datacreance=[];
                            t.allgraphsclient=[];
                            t.allgraphscreance=[];
                            t.isdisplay=true;
                        }


                    })
                    .catch((error)=>{

                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })




            },

            close(){

                this.isdisplay=false;

                //this.$emit('closed');

            },

            show(titlemodal){


                this.messagesucces="";
                this.messageerror="";
                this.titlemodal="Principaux clients et montants dus au d'une année"

                this.datatable=[];

                this.mmois=currentMonth();
                    this.manne=currentYear();
                    this.listedesannees=getYear2020();

                this.load()



            },






            //****************************************************************//

            setPages (posts) {
                this.pages=[];
                // let numberOfPages = Math.ceil(this.datatable.length / this.perPage);
                let numberOfPages = Math.ceil(posts.length / this.perPage);
                for (let index = 1; index <= numberOfPages; index++) {

                    this.pages.push(index);
                }
            },
            paginate (posts) {

                this.setPages(posts)
                let page = this.page;
                let perPage = this.perPage;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);

                let $res=posts.slice(from, to)

                if ($res.length>0){
                    return $res;
                }else{

                    return posts;
                }

                // return  posts.slice(from, to);
            }



        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:94vh; overflow:hidden; }
.cf-dialog--xxl { max-width:1200px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

.th { position:sticky; top:0; z-index:2; padding:0.7rem 1rem; font-weight:600; font-size:0.75rem; color:var(--cf-ink); background:var(--cf-surface-alt); border-bottom:1px solid var(--cf-border); white-space:nowrap; letter-spacing:0.02em; text-align:left; }
.table-row { border-bottom:1px solid var(--cf-surface-alt); transition:background-color .15s; }
.table-row:hover { background:var(--cf-surface); }
.td { padding:0.65rem 1rem; font-size:0.82rem; color:var(--cf-ink); vertical-align:middle; white-space:nowrap; }
.td--center { text-align:center; }

.empty-state { padding:2.5rem 1.5rem; text-align:center; }
.empty-state__icon { font-size:40px; color:var(--cf-faint); margin-bottom:14px; }
.empty-state__title { font-size:0.95rem; font-weight:600; color:var(--cf-ink-strong); margin:0; }
.empty-state__sub { font-size:0.8rem; color:var(--cf-muted); margin:4px 0 0; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

    .table td {
        cursor: pointer;
    }

    .h-screen{

        height: 300px!important;

    }

    .mybodyheight200px{
        height: 200px;
    }

    .mybodyheight300px{
        height: 300px;
    }

    .mybodyheight400px{
        height: 400px;
    }

    .mybodyheight500px{
        height: 500px;
    }

    @media screen and (max-width: 768px) {

        .cf-dialog--xxl { max-width:100%; }


        .h-screen,.mybodyheight200px,.mybodyheight300px, .mybodyheight400px,.mybodyheight500px{
            height: 100%!important;
        }


    }

</style>